import {
  Button,
  ButtonColor,
} from 'modules/common/components/_ui/Button/Button'
import { useHideModalContext } from 'modules/common/contexts/HideModalContext'
import { useState } from 'react'

export interface CtaModalFooterProps {
  secondaryButtonText?: string
  onSecondaryClick?: () => unknown
  primaryButtonText: string
  primaryButtonColor?: ButtonColor
  onPrimaryClick?: () => unknown
  buttonsAlignment?: 'center' | 'stretch'
  hiddenOnError?: boolean
  primaryButtonDisabled?: boolean
}

export const CtaModalFooter = ({
  secondaryButtonText,
  onSecondaryClick,
  primaryButtonText,
  primaryButtonDisabled = false,
  primaryButtonColor = 'active',
  onPrimaryClick,
  buttonsAlignment = 'stretch',
  hiddenOnError = false,
}: CtaModalFooterProps) => {
  const [isLoading, setIsLoading] = useState(false)
  const hideModal = useHideModalContext()

  const buttonClassName =
    buttonsAlignment === 'stretch' ? 'min-w-full sm:min-w-0 flex-1' : ''

  return (
    <>
      {secondaryButtonText && (
        <Button
          variant="outline"
          color="active"
          onClick={async () => {
            if (onSecondaryClick) {
              await onSecondaryClick()
            }
            hideModal()
          }}
          data-testid="secondary-modal-button"
          className={buttonClassName}
        >
          {secondaryButtonText}
        </Button>
      )}

      <Button
        disabled={primaryButtonDisabled}
        variant="contained"
        color={primaryButtonColor}
        onClick={async () => {
          setIsLoading(true)
          try {
            onPrimaryClick && (await onPrimaryClick())
            hideModal()
          } catch {
            hiddenOnError && hideModal()
          } finally {
            setIsLoading(false)
          }
        }}
        data-testid="primary-modal-button"
        className={buttonClassName}
        isLoading={isLoading}
      >
        {primaryButtonText}
      </Button>
    </>
  )
}
